<template>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="中心名称" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input placeholder="请输入中心名称" v-model="queryParam.name" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="中心编码" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input placeholder="请输入中心编码" v-model="queryParam.code" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" style="text-align: left">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a-button v-has="'center:add'" @click="handleEdit" type="primary" icon="plus" style="margin-left: 8px" >新增</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table :columns="columns"
               size="small"
               :scroll="{y:'500px',x: '100%'}"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               @change="handleTableChange">
      >
      <span slot="action" slot-scope="text,record,index">
        <a v-has="'center:update'" @click="handleEdit(record)">编辑</a>
      </span>
      </a-table>
      <a-modal
        title="中心信息"
        :width="500"
        :visible="formVisible"
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleCancel">
       <a-form-model :model="formData" layout="horizontal" style="padding-left: 20px;padding-right: 20px;"
              v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 } }" ref="centerForm">
            <a-form-model-item label="中心名称" prop="name" :rules="[ { required: true, message: '请输入中心名称', trigger: 'blur' } ]">
              <a-input placeholder="请输入中心名称" v-model="formData.name" style="width: 100%;" />
            </a-form-model-item>
            <a-form-model-item label="中心管理员" prop="userName" :rules="[ { required: true, message: '请选择管理员', trigger: 'blur' } ]">
              <a-input placeholder="请选择管理员" v-model="formData.userName" style="width: 85%;" :disabled="true" />
              <a-button icon="search" style="margin-left: 10px" @click="selectUserView()"></a-button>
            </a-form-model-item>
            <a-form-model-item label="联系电话" prop="phone"  :rules="[ { required: true, message: '请输入联系电话', trigger: 'blur' } ]">
              <a-input placeholder="请输入联系电话" v-model="formData.phone" style="width: 100%;" :disabled="true" />
            </a-form-model-item>
          </a-form-model>
      </a-modal>
       <Select-User-Modal ref="selectUserModal" :single="'1'" @selectFinished="selectUserOK"></Select-User-Modal>
    </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction,putAction } from '@/api/manage'
  import SelectUserModal from '../../system/modules/SelectUserModal'
  import Vue from 'vue'

  export default {
    name: 'Center',
    mixins:[JeecgListMixin],
    components: { SelectUserModal },
    data(){
      return {
        columns:[
          {
            title: '中心编码',
            align:'center',
            dataIndex: 'center.code',
            width: 100,
          },
          {
            title: '中心名称',
            align:'center',
            dataIndex: 'center.name',
            width: 150,
          },
          // {
          //   title: '成员数',
          //   align:'center',
          //   dataIndex: 'personNum',
          //   width: 100,
          // },
          {
            title: '中心管理员',
            align:'center',
            dataIndex: 'center.userName',
            width: 150,
          },
          {
            title: '联系电话',
            align:'center',
            dataIndex: 'center.phone',
            width: 200,
          },
          {
            title: '注册病例数',
            align:'center',
            dataIndex: 'patientNum',
            width: 150,
          },
          {
            title: '入组病例数',
            align:'center',
            dataIndex: 'groupPatientNum',
            width: 150,
          },
          // {
          //   title: '已提交表单数',
          //   align:'center',
          //   dataIndex: 'submitFormNum',
          //   width: 150,
          // },
          {
            title: '操作',
            align:'center',
            width: 100,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          }
        ],
        disableMixinCreated:true,
        url: {
          list: "/project/center/list",
        },
        formVisible:false,
        confirmLoading:false,
        formData:{},
        projectId: Vue.ls.get(CACHE_PROJECT_ID)
      }
    },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()      
    },
    methods:{
       selectUserView(){
        this.$refs.selectUserModal.visible = true;
      },
      selectUserOK(keys,records){
        const record = records[0]
        this.$set(this.formData,'userId',record.id)
        this.$set(this.formData,'userName',record.realname)
        this.$set(this.formData,'phone',record.phone)
      },
      handleEdit(record){
        this.formData = Object.assign({},record.center)
        this.formVisible = true
      },

      handleSubmit(){
        this.$refs.centerForm.validate((valid) => {
        if (valid) {
           this.formData.projectId = this.projectId
           postAction('/management/center/saveToProject',this.formData).then(res=>{
              if(res.success){
                this.searchQuery()
                this.handleCancel()
              }
            })
        }else{
            console.log('表单验证失败');
          }})
      },
      handleCancel(){
        this.formData = {}
        this.formVisible = false
      },
    }
  }
</script>

<style scoped>
  
</style>